import ajax from "../../lib/appfuse-react/core/ajax";

const organizationService = {
    get: async () => {
        const response = await ajax.get('organization/one');
        return response.data;
    }
}

export default organizationService;